module.exports = __webpack_public_path__ + "img/Shiba-BG.8458fa6b.jpg";